import { Injectable, Injector, ComponentFactoryResolver, ApplicationRef, Renderer2, ComponentRef, Type, RendererFactory2 } from '@angular/core';
import { isNil } from 'lodash';
import { SidebarComponent } from '../components/sidebar/sidebar.component';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private _renderer: Renderer2;
  private _componentRef: ComponentRef<SidebarComponent> | null = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private rendererFactory: RendererFactory2,
  ) {
    this._renderer = this.rendererFactory.createRenderer(null, null);
  }

  showComponent(component: Type<SidebarComponent>, data: any | null = null) {
    if (!isNil(this._componentRef)) {
      this.destroyComponent();
    }

    this._componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
    this._componentRef.instance.data = data;

    this.appRef.attachView(this._componentRef.hostView);

    const domElem = (this._componentRef.hostView as any).rootNodes[0];

    this._renderer.appendChild(document.body, domElem);
  }

  destroyComponent() {
    if (isNil(this._componentRef)) {
      return;
    }

    this.appRef.detachView(this._componentRef.hostView);
    this._componentRef.destroy();

    this._componentRef = null;
  }
}
